<template>
    <div>
        <h1>의료 마이데이터 건강검진정보(민감정보) 수집·이용 동의</h1>
        주식회사 솔닥(이하 “회사”라 합니다)은 의료 마이데이터 서비스를 통해 회원의 건강검진정보를 조회·관리하고 건강정보 서비스를 제공하기 위해 아래와 같이 민감정보를 수집·이용합니다.<br>
        본 동의는 해당 서비스 제공을 위해 필요한 필수 동의이며, 동의하지 않을 경우 해당 의료 마이데이터 서비스를 이용할 수 없습니다.<br>
        <h3>제1조 (민감정보 활용 목적)</h3>
        1. 회사는 회원의 건강검진정보를 활용하여 다음의 맞춤형 건강 서비스를 제공합니다.<br>
        가. 건강검진정보의 이해를 돕기 위한 요약, 분류, 시각화 및 관리 정보 제공<br>
        2. 회사는 본 동의에 따른 민감정보를 위 목적 범위 내에서만 활용하며, 광고성 정보 발송 또는 마케팅·제휴 상품 홍보 목적으로 활용하지 않습니다.<br>
        <h3>제2조 (활용하는 민감정보 항목)</h3>
        1. 회사는 회원이 의료 마이데이터 서비스를 통해 전송요구하고 회사가 전송받은 정보 중 건강검진정보를 활용합니다.<br>
        2. 회사는 맞춤형 건강 서비스 제공에 필요한 최소한의 민감정보만 활용합니다.<br>
        <h3>제3조 (맞춤형 건강 서비스의 내용)</h3>
        1. 회사는 회원의 건강검진정보를 활용하여 건강검진 결과에 대한 요약, 분류, 시각화, 건강관리 안내 등 회원의 건강정보 이해와 관리를 지원하는 서비스를 제공할 수 있습니다.<br>
        2. 회사가 제공하는 정보는 회원의 건강정보 이해와 건강관리를 돕기 위한 참고 정보이며, 의료진의 진단, 처방, 치료 또는 의학적 판단을 대체하지 않습니다.<br>
        <h3>제4조 (민감정보의 보유 및 이용기간)</h3>
        1. 회사는 본 동의에 따라 활용하는 민감정보를 회원이 본 동의를 유지하는 기간 동안 보유·이용합니다.<br>
        2. 다음 각 호의 어느 하나에 해당하는 경우 회사는 본 동의에 따른 맞춤형 건강 서비스 제공을 중단합니다.<br>
        가. 회원이 본 동의를 철회한 경우<br>
        나. 회원이 마이데이터 연동을 해지하거나 전송요구를 철회 후 데이터 삭제를 요청하는 경우<br>
        다. 회원이 솔닥 회원을 탈퇴한 경우<br>
        라. 회원이 민감정보 삭제 또는 파기를 요청한 경우<br>
        <h3>제5조 (동의 거부 및 철회)</h3>
        1. 회원은 민감정보 수집·이용에 대한 동의를 거부할 권리가 있습니다.<br>
        2. 다만, 본 동의는 의료 마이데이터를 통한 건강검진정보 조회·관리 및 관련 서비스 제공에 필요한 필수 동의이므로, 동의를 거부할 경우 해당 서비스를 이용할 수 없습니다.
    </div>
</template>

<script>
export default {
    name: 'mydataPersonalizedService'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/mydata/PersonalizedService.vue